import { BACKGROUND_OPTIONS, Dialog } from "@ui/components/Dialog";
import { Typography } from "@ui/components/Typography";
import { useTranslations } from "@ui/providers/useTranslations";

import { Button } from "@jti/core-components/components/Button";

import styles from "./AgeEstimationFallbackDialog.module.scss";

const TITLE_ID = "age-estimation-fallback-title";

export type AgeEstimationFallbackDialogProps = {
  isOpened: boolean;
  isPending: boolean;
  onClose: () => void;
  onContinue: () => void;
};

export const AgeEstimationFallbackDialog = ({
  isOpened,
  isPending,
  onClose,
  onContinue,
}: AgeEstimationFallbackDialogProps) => {
  const { __ } = useTranslations();

  return (
    <Dialog
      ariaLabelledBy={TITLE_ID}
      backgroundBlur={BACKGROUND_OPTIONS.blurredBlack.blur}
      backgroundColor={BACKGROUND_OPTIONS.blurredBlack.color}
      contentWrapperClassName={styles.container}
      dataTestId="ageEstimationFallbackDialog"
      isOpened={isOpened}
      onClose={onClose}
    >
      <div id={TITLE_ID}>
        <Typography variant="h3" className={styles.title}>
          {__("ageverification.age_estimation_fallback.title")}
        </Typography>
      </div>
      <Typography variant="body2" weight="light" className={styles.description}>
        {__("ageverification.age_estimation_fallback.description")}
      </Typography>
      <Button variant="primary" pending={isPending} onClick={onContinue}>
        {__("ageverification.age_estimation_fallback.cta")}
      </Button>
    </Dialog>
  );
};
